import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material'
import React from 'react'

// region TypeScript Interfaces
interface NavigationLinkProps {
  title: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}
// endregion

const NavTypography = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  transition: 'color 0.15s ease-in-out',
  '&:hover': {
    transition: 'color 0.15s ease-in-out',
    color: (theme.palette as any).tertiary?.main || theme.palette.primary.main
  }
}))

export const NavigationLink = (props: NavigationLinkProps) => {
  return (
    <NavTypography onClick={props.onClick}>
      {props.title}
    </NavTypography>
  )
}
